import {BaseContainerModel} from "../../base-container.model";
import {
  bl_wf_issue_to_issue_link_RowInterface,
  bl_wf_issue_to_issue_link_RowClass
} from "../../../dbschema";

export class WfIssueToIssueLinkContainerModel extends BaseContainerModel {
  bl_wf_issue_to_issue_link: bl_wf_issue_to_issue_link_RowInterface = new bl_wf_issue_to_issue_link_RowClass();
}
